/* ============================================
   ET Bundle — PDP-002 custom Kaching UI
   Mounts custom selector + Mix & Match side panel
   next to <kaching-bundle> when body.test-pdp-005 is present.
   Submits cart via direct POST mirroring Kaching's format.
   ============================================ */
   (function () {
    'use strict';
  
    const TEST_CLASS = 'test-pdp-005';
    const BUNDLE_ATTR = 'data-et-bundle-mounted';
    const instances = new WeakMap();
  
    // ---------- i18n ----------
    // All translatable strings are passed in via `window.ETBundleI18n`
    // (populated by snippets/et-bundle-test-pdp-005.liquid from block.settings).
    // Fallbacks below are only safety nets — production strings come from theme editor.
    const I18N_DEFAULTS = {
      // Selector
      heading_bundle_save: 'BUNDLE & SAVE',
      tier_badge_format: 'SAVE {n}%',
      tier1_title: 'Single Item',
      tier1_subtitle: '',
      tier2_title: 'Bestseller Bundle',
      tier2_subtitle: 'Most popular',
      tier3_title: 'Performance Bundle',
      tier3_subtitle: 'Best value',
      // Build Your Bundle tier
      build_title: 'Build Your Bundle',
      build_subtitle: 'Your choice',
      build_badge: 'UP TO 60%',
      build_price_prefix: 'From',
      build_description: 'Create your perfect training bundle and save more with every item you add',
      build_cta: 'Make my combination',
      // Knowledge Hub upsell
      hub_heading: 'Knowledge hub Recommendations',
      upsell_subtitle: 'Full Video Training Guide',
      // Mix & Match modal (Build Your Bundle)
      modal_title: 'Mix & Match',
      modal_description: 'Mix & Match: buy more products, save more with discounts. Choose at least one product and immediately get the discount.',
      combo_show: 'Show My Combination',
      combo_hide: 'Hide My Combination',
      product_singular: 'product',
      product_plural: 'products',
      atc_button: 'Add to cart',
      atc_adding: 'Adding…',
      savings_prefix: 'Saving',
      card_add_button: 'ADD',
      combo_empty: 'Nothing picked yet',
    };
    const t = (key) => (window.ETBundleI18n && window.ETBundleI18n[key]) || I18N_DEFAULTS[key] || '';
    const pluralProduct = (n) => n === 1 ? t('product_singular') : t('product_plural');
  
    // ---------- helpers ----------
    /*
      Shopify's money placeholders, each with its own decimal count, thousands
      separator and decimal separator. Every one of them has to be here: a market
      whose format uses a placeholder we do not know — Sweden's
      "{{amount_with_space_separator}} kr" — would otherwise print the placeholder
      itself where the price belongs.
    */
    const MONEY_FORMATS = {
      amount: [2, ',', '.'],
      amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','],
      amount_no_decimals_with_comma_separator: [0, '.', ','],
      amount_with_space_separator: [2, ' ', ','],
      amount_no_decimals_with_space_separator: [0, ' ', ','],
      amount_with_apostrophe_separator: [2, "'", '.'],
      amount_no_decimals_with_apostrophe_separator: [0, "'", '.']
    };

    const MONEY_PLACEHOLDER = /\{\{\s*(\w+)\s*\}\}/;

    const fmtMoney = (cents, format) => {
      const amount = Number(cents) || 0;
      const match = String(format || '').match(MONEY_PLACEHOLDER);
      const rule = match ? MONEY_FORMATS[match[1]] : null;

      // Group the thousands the way the format asks for, e.g. 1 234,50 in Sweden
      const precision = rule ? rule[0] : 2;
      const parts = (amount / 100).toFixed(precision).split('.');
      const whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (rule ? rule[1] : ','));
      const value = whole + (parts[1] ? (rule ? rule[2] : '.') + parts[1] : '');

      // An unusable format leaves the amount to stand on its own
      return match ? format.replace(MONEY_PLACEHOLDER, value) : value;
    };
  
    const ceilToPrecision = (cents, precisionStr) => {
      if (!precisionStr || precisionStr === 'none') return Math.round(cents);
      const p = parseFloat(precisionStr);
      const target = Math.round(p * 100);
      const whole = Math.ceil((cents + (100 - target)) / 100) * 100;
      return whole - (100 - target);
    };
  
    const nonce = () => Math.random().toString(36).slice(2, 8);
  
    const escapeHtml = (s) =>
      String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
  
    const parseJsonAttr = (el, name) => {
      const raw = el.getAttribute(name);
      if (!raw) return null;
      try { return JSON.parse(raw); } catch (e) { console.warn('[et-bundle] bad JSON in', name, e); return null; }
    };
  
    // ---------- color swatch detection ----------
    const COLOR_MAP = {
      black: '#000000', white: '#FFFFFF', red: '#E53935', blue: '#1E88E5',
      green: '#43A047', yellow: '#FDD835', grey: '#808080', gray: '#808080',
      orange: '#FB8C00', pink: '#EC407A', purple: '#8E24AA', brown: '#6D4C41',
      silver: '#BDBDBD', gold: '#D4AF37', navy: '#0D47A1', beige: '#E8DCC4',
      cream: '#F5EBDC', tan: '#D2B48C', olive: '#808000', teal: '#00897B',
      cyan: '#00ACC1', magenta: '#D81B60', maroon: '#800000', lime: '#C0CA33',
      coral: '#FF7F50', mint: '#98D8B5', ivory: '#FFFFF0', khaki: '#BDB76B', turquoise: '#40e0d0',
    };
    function getOptionColor(name) {
      if (!name) return null;
      const key = String(name).toLowerCase().trim();
      if (COLOR_MAP[key]) return COLOR_MAP[key];
      for (const [k, v] of Object.entries(COLOR_MAP)) {
        if (key.includes(k)) return v;
      }
      return null;
    }
    function isColorOption(option) {
      if (!option) return false;
      const name = String(option.name || '').toLowerCase();
      if (/colou?r|кольор|цвет|farbe/.test(name)) return true;
      const values = option.optionValues || [];
      if (!values.length) return false;
      const colorCount = values.filter((v) => getOptionColor(v.name)).length;
      return colorCount === values.length;
    }
  
    // ---------- init / observation ----------
    const initIfReady = () => {
      if (!document.body.classList.contains(TEST_CLASS)) return;
      document.querySelectorAll('kaching-bundles-block').forEach((block) => {
        if (block.hasAttribute(BUNDLE_ATTR)) return;
        mount(block);
      });
    };
  
    // Watch for body class toggle (Intelligems may add late)
    new MutationObserver(initIfReady).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  
    // Watch for late-injected kaching components
    new MutationObserver((muts) => {
      for (const m of muts) {
        for (const n of m.addedNodes) {
          if (n.nodeType !== 1) continue;
          if (n.matches?.('kaching-bundles-block') || n.querySelector?.('kaching-bundles-block')) {
            initIfReady();
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  
    document.addEventListener('DOMContentLoaded', initIfReady);
    if (document.readyState !== 'loading') initIfReady();
  
    // ---------- mount one bundle ----------
    function mount(block) {
      block.setAttribute(BUNDLE_ATTR, '1');
  
      const cfg = readConfig(block);
      if (!cfg) {
        console.warn('[et-bundle] failed to parse Kaching config — skipping');
        return;
      }
  
      const state = {
        // Index into the derived tiers[] array (quantity tiers first, Build last).
        selectedTierIndex: 0,
        upsellOn: !!(cfg.checkboxUpsells?.[0]?.preselected),
        modalOpen: false,
        footerOpen: false,
        // picks: { [productId]: { variantId, quantity } } — used by the Build (mix) modal.
        picks: {},
        // selectedVariants: { [productId]: variantId } — variant currently displayed
        // in a slot dropdown / modal card. Also seeds preset-tier slot variants.
        selectedVariants: {},
      };

      // Seed the source product's displayed variant + a modal pick with the PDP variant.
      if (cfg.product?.id) {
        state.selectedVariants[cfg.product.id] = cfg.currentVariantId;
        state.picks[cfg.product.id] = {
          variantId: cfg.currentVariantId,
          quantity: 1,
          source: true,
        };
      }
  
      const root = document.createElement('div');
      root.className = 'et-bundle';
      root.setAttribute('data-product-id', cfg.product?.id || '');
  
      // Insert next to native kaching-bundle host
      const host = block.closest('kaching-bundle') || block;
      host.parentNode.insertBefore(root, host.nextSibling);
  
      instances.set(block, { cfg, state, root });

      renderSelector(block);
      renderModal(block);
      bindNativeAtc(block);

      // Re-render on ANY block attribute change.
      // Kaching widgetLoader populates other-products / collection-breaks-products
      // asynchronously, after the element is in DOM. We watch all attrs and
      // re-parse on every change, so the UI catches up once data lands.
      new MutationObserver(() => {
        const newCfg = readConfig(block);
        if (!newCfg) return;
        const inst = instances.get(block);
        if (!inst) return;
        // Keep the PDP variant in sync for the source product (modal pick + slot display).
        const newVariantId = newCfg.currentVariantId;
        if (newVariantId && inst.state.picks[newCfg.product.id]?.source) {
          inst.state.picks[newCfg.product.id].variantId = newVariantId;
          // Only follow the PDP selector if the user hasn't overridden the slot variant.
          if (!inst.state.variantTouched?.[newCfg.product.id]) {
            inst.state.selectedVariants[newCfg.product.id] = newVariantId;
          }
        }
        inst.cfg = newCfg;
        renderSelector(block);
        renderModal(block);
        bindNativeAtc(block); // retry in case the theme form mounted after us
        deselectKachingUpsell(); // keep Kaching from auto-adding its upsell
      }).observe(block, { attributes: true });
    }
  
    function readConfig(block) {
      const cfg = {
        config: parseJsonAttr(block, 'config'),
        dealBlock: parseJsonAttr(block, 'deal-block'),
        product: parseJsonAttr(block, 'product'),
        otherProducts: parseJsonAttr(block, 'other-products') || [],
        // Mix & Match modal products. Prefer the collection picked in the block
        // setting (window.ETBundleModalProducts, in the collection's own sort
        // order); fall back to Kaching's collection-breaks-products.
        collectionBreaks: (Array.isArray(window.ETBundleModalProducts) && window.ETBundleModalProducts.length)
          ? window.ETBundleModalProducts
          : (parseJsonAttr(block, 'collection-breaks-products') || []),
        checkboxUpsells: null,
        currentVariantId: parseInt(block.getAttribute('current-variant-id'), 10),
        // Products for Bestseller/Performance tier slots, from the product
        // "Bundle Option Products" metafield (populated by the snippet).
        bundleProducts: Array.isArray(window.ETBundleProducts) ? window.ETBundleProducts : [],
        // productId -> subtitle, from the "Bundle Product Subtitle" metafield.
        subtitles: (window.ETBundleSubtitles && typeof window.ETBundleSubtitles === 'object') ? window.ETBundleSubtitles : {},
      };
      if (!cfg.dealBlock || !cfg.product) return null;
  
      cfg.dealBars = cfg.dealBlock.dealBars || [];
      cfg.dealNanoId = cfg.dealBlock.nanoId; // e.g. "_002"
      cfg.checkboxUpsells = cfg.dealBlock.checkboxUpsells?.upsells || [];
      cfg.checkboxUpsellsEnabled = !!cfg.dealBlock.checkboxUpsellsEnabled;
      // Kaching reports the active market's format; the theme's own is the backstop
      cfg.moneyFormat =
        cfg.config?.moneyFormat ||
        window.theme?.settings?.money_with_currency_format ||
        '€{{amount_with_comma_separator}}';
      cfg.priceRoundingPrecision = cfg.dealBlock.priceRounding ? (cfg.dealBlock.priceRoundingPrecision || '.95') : null;
      cfg.useCompareAt = cfg.dealBlock.useProductCompareAtPrice !== false;
  
      return cfg;
    }
  
    // ---------- pricing ----------
    function findVariant(productOrList, variantId) {
      if (!productOrList) return null;
      const list = Array.isArray(productOrList) ? productOrList : [productOrList];
      for (const p of list) {
        const v = p.variants?.find((x) => x.id === variantId);
        if (v) return v;
      }
      return null;
    }
    function currentVariant(cfg) {
      return findVariant(cfg.product, cfg.currentVariantId) || cfg.product.variants?.[0];
    }
    function applyTierDiscount(cents, dealBar, cfg) {
      if (!dealBar) return cents;
      if (dealBar.discountType === 'percentage' && typeof dealBar.discountValue === 'number') {
        const after = cents * (1 - dealBar.discountValue / 100);
        return cfg.priceRoundingPrecision ? ceilToPrecision(after, cfg.priceRoundingPrecision) : Math.round(after);
      }
      return cents;
    }
    function cheapestMixUnit(cfg) {
      // For "From X" — use cheapest variant across collectionBreaks for tier 2 (qty 2)
      let cheapest = currentVariant(cfg)?.price || 0;
      for (const p of cfg.collectionBreaks) {
        for (const v of p.variants || []) {
          if (v.availableForSale && v.price < cheapest) cheapest = v.price;
        }
      }
      return cheapest;
    }
  
    // ---------- tier model ----------
    // Build the ordered tiers[] from Kaching quantity-break bars.
    // Up to 3 quantity tiers (mapped to configurable Single/Bestseller/Performance
    // copy) + a final "Build Your Bundle" (mix) tier that opens the modal.
    function buildTiers(cfg) {
      const copy = [
        { title: t('tier1_title'), subtitle: t('tier1_subtitle') },
        { title: t('tier2_title'), subtitle: t('tier2_subtitle') },
        { title: t('tier3_title'), subtitle: t('tier3_subtitle') },
      ];
      const qb = (cfg.dealBars || [])
        .filter((b) => b.dealBarType === 'quantity-break')
        .slice()
        .sort((a, b) => a.quantity - b.quantity);

      const tiers = [];
      const hasSingle = qb.some((b) => b.quantity === 1);
      if (!hasSingle) {
        // Synthesize a quantity-1 tier when Kaching has no qty-1 break.
        tiers.push({ type: 'qty', quantity: 1, bar: null, ...copy[0] });
        qb.filter((b) => b.quantity >= 2).slice(0, 2).forEach((bar, i) => {
          tiers.push({ type: 'qty', quantity: bar.quantity, bar, ...(copy[i + 1] || copy[copy.length - 1]) });
        });
      } else {
        qb.slice(0, 3).forEach((bar, i) => {
          tiers.push({ type: 'qty', quantity: bar.quantity, bar, ...(copy[i] || copy[copy.length - 1]) });
        });
      }
      tiers.push({ type: 'build', title: t('build_title'), subtitle: t('build_subtitle') });
      return tiers;
    }

    // Preset slot products for a quantity tier: source product first, then the
    // "Bundle Option Products" metafield list in order.
    // Single (qty 1) → [source]; Bestseller (2) → [source, bundle[0]];
    // Performance (3) → [source, bundle[0], bundle[1]].
    function presetSlots(cfg, qty) {
      const extras = (cfg.bundleProducts || []).filter((p) => p && p.id !== cfg.product.id);
      const pool = [cfg.product, ...extras];
      return pool.slice(0, Math.max(1, qty));
    }

    function slotVariant(p, state) {
      return findVariant(p, getDisplayVariantId(p, state))
        || p.variants?.find((x) => x.availableForSale)
        || p.variants?.[0];
    }

    function tierPricing(cfg, tier, state) {
      if (tier.type === 'build') {
        // "From" price = the current product's selected variant price.
        return { from: currentVariant(cfg)?.price || cheapestMixUnit(cfg) };
      }
      const slots = presetSlots(cfg, tier.quantity);
      let price = 0, compare = 0;
      for (const p of slots) {
        const v = slotVariant(p, state);
        if (!v) continue;
        price += v.price;
        compare += (v.compareAtPrice && v.compareAtPrice > v.price) ? v.compareAtPrice : v.price;
      }
      const total = applyTierDiscount(price, tier.bar, cfg);
      const savingsPct = compare > total ? Math.round((1 - total / compare) * 100 / 5) * 5 : 0;
      return { total, compare, savingsPct };
    }

    const formatBadge = (fmt, n) => String(fmt || '').replace('{n}', n);

    // ---------- selector render ----------
    function renderSelector(block) {
      const inst = instances.get(block);
      if (!inst) return;
      const { cfg, state, root } = inst;

      const tiers = buildTiers(cfg);
      inst.tiers = tiers;
      if (state.selectedTierIndex >= tiers.length) state.selectedTierIndex = 0;

      root.innerHTML = `
        <div class="et-bundle__header">
          <h3 class="et-bundle__heading">${escapeHtml(t('heading_bundle_save'))}</h3>
        </div>

        <div class="et-bundle__selector">
          ${tiers.map((tier, i) => renderTier(tier, i, state, cfg)).join('')}
        </div>

        ${renderHub(cfg, state)}
      `;

      // ----- wire up -----
      root.querySelectorAll('.et-bundle__tier').forEach((el) => {
        el.addEventListener('click', (ev) => {
          if (ev.target.closest('[data-action]') || ev.target.closest('.et-bundle__slot-select')) return;
          const idx = parseInt(el.dataset.tierIndex, 10);
          if (idx === state.selectedTierIndex) return;
          state.selectedTierIndex = idx;
          renderSelector(block);
        });
      });

      root.querySelector('[data-action="open-modal"]')?.addEventListener('click', () => {
        const buildIdx = tiers.findIndex((tr) => tr.type === 'build');
        if (buildIdx >= 0) state.selectedTierIndex = buildIdx;
        state.modalOpen = true;
        renderSelector(block);
        renderModal(block);
      });

      root.querySelector('[data-action="toggle-upsell"]')?.addEventListener('click', () => {
        state.upsellOn = !state.upsellOn;
        renderSelector(block);
      });

      // Slot variant dropdowns
      root.querySelectorAll('[data-action="slot-variant"]').forEach((sel) => {
        sel.addEventListener('change', (e) => {
          const pid = parseInt(sel.closest('.et-bundle__slot').dataset.productId, 10);
          const vid = parseInt(e.target.value, 10);
          state.selectedVariants = state.selectedVariants || {};
          state.selectedVariants[pid] = vid;
          state.variantTouched = state.variantTouched || {};
          state.variantTouched[pid] = true;
          if (state.picks[pid]) state.picks[pid].variantId = vid;
          renderSelector(block);
        });
      });
    }

    const CHEVRON_DOWN = '<svg class="et-bundle__chev" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function renderTier(tier, i, state, cfg) {
      const selected = i === state.selectedTierIndex;
      const pricing = tierPricing(cfg, tier, state);

      let badge = '';
      let prices = '';
      let expand = '';

      if (tier.type === 'build') {
        badge = t('build_badge') ? `<span class="et-bundle__pill">${escapeHtml(t('build_badge'))}</span>` : '';
        prices = `
          <div class="et-bundle__prices et-bundle__prices--build">
            <span class="et-bundle__price-prefix">${escapeHtml(t('build_price_prefix'))}</span>
            <span class="et-bundle__price et-bundle__price--build">${fmtMoney(pricing.from, cfg.moneyFormat)}</span>
          </div>`;
        expand = `
          <div class="et-bundle__tier-expand">
            <div class="et-bundle__tier-divider"></div>
            <p class="et-bundle__build-desc">${escapeHtml(t('build_description'))}</p>
            <button type="button" class="et-bundle__build-cta" data-action="open-modal">
              <span class="et-bundle__build-cta-text">${escapeHtml(t('build_cta'))}</span>
              <svg class="et-bundle__build-cta-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </button>
          </div>`;
      } else {
        if (pricing.savingsPct > 0) {
          badge = `<span class="et-bundle__pill">${escapeHtml(formatBadge(t('tier_badge_format'), pricing.savingsPct))}</span>`;
        }
        prices = `
          <div class="et-bundle__prices">
            <span class="et-bundle__price et-bundle__price--sale">${fmtMoney(pricing.total, cfg.moneyFormat)}</span>
            ${pricing.compare > pricing.total ? `<span class="et-bundle__compare">${fmtMoney(pricing.compare, cfg.moneyFormat)}</span>` : ''}
          </div>`;
        const slots = presetSlots(cfg, tier.quantity);
        expand = `
          <div class="et-bundle__tier-expand">
            <div class="et-bundle__tier-divider"></div>
            <div class="et-bundle__slots">
              ${slots.map((p, si) => (si > 0 ? renderSlotPlus() : '') + renderSlot(p, state, cfg)).join('')}
            </div>
          </div>`;
      }

      return `
        <div class="et-bundle__tier ${selected ? 'is-selected' : ''} ${tier.type === 'build' ? 'et-bundle__tier--build' : ''}" data-tier-index="${i}">
          <div class="et-bundle__tier-row">
            <span class="et-bundle__radio" aria-hidden="true"></span>
            <div class="et-bundle__tier-main">
              <div class="et-bundle__tier-titles">
                <div class="et-bundle__tier-title-row">
                  <h4 class="et-bundle__tier-title">${escapeHtml(tier.title)}</h4>
                  ${badge}
                </div>
                ${tier.subtitle ? `<span class="et-bundle__tier-subtitle">${escapeHtml(tier.subtitle)}</span>` : ''}
              </div>
              ${prices}
            </div>
          </div>
          ${selected ? expand : ''}
        </div>`;
    }

    function renderSlotPlus() {
      return `
        <div class="et-bundle__slot-plus" aria-hidden="true">
          <span class="et-bundle__slot-line"></span>
          <svg viewBox="0 0 12 12" fill="none"><path d="M6 1v10M1 6h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
          <span class="et-bundle__slot-line"></span>
        </div>`;
    }

    function renderSlot(p, state, cfg) {
      const v = slotVariant(p, state);
      const img = p.image || v?.image || '';
      const avail = (p.variants || []).filter((x) => x.availableForSale);
      const label = v?.options?.[0] || '';
      const isDefault = !label || label.toLowerCase() === 'default title';
      const multi = avail.length > 1;
      const subtitle = cfg?.subtitles?.[p.id];
      return `
        <div class="et-bundle__slot" data-product-id="${p.id}">
          <div class="et-bundle__slot-thumb" style="background-image:url('${escapeHtml(img)}');"></div>
          <div class="et-bundle__slot-body">
            <h5 class="et-bundle__slot-title">${escapeHtml(p.title)}</h5>
            ${subtitle ? `<p class="et-bundle__slot-subtitle">${escapeHtml(subtitle)}</p>` : ''}
          </div>
          ${isDefault ? '' : `
            <div class="et-bundle__slot-select ${multi ? 'is-multi' : ''}">
              <span class="et-bundle__slot-select-value">${escapeHtml(label)}</span>
              ${multi ? CHEVRON_DOWN : ''}
              ${multi ? `<select class="et-bundle__slot-native" data-action="slot-variant" aria-label="${escapeHtml(p.title)}">
                ${avail.map((x) => `<option value="${x.id}" ${x.id === v.id ? 'selected' : ''}>${escapeHtml(x.options?.[0] || '')}${x.options?.[1] ? ` (${escapeHtml(x.options[1])})` : ''}</option>`).join('')}
              </select>` : ''}
            </div>`}
        </div>`;
    }

    // ---------- Knowledge Hub upsell (checkbox product) ----------
    function resolveUpsell(cfg) {
      const upsellEntry = cfg.checkboxUpsellsEnabled !== false ? cfg.checkboxUpsells?.[0] : null;
      if (!upsellEntry) return null;
      const wantedId = (upsellEntry.productGID || '').replace('gid://shopify/Product/', '');
      const product =
        cfg.otherProducts.find((p) => String(p.id) === wantedId) ||
        cfg.otherProducts.find((p) => 'gid://shopify/Product/' + p.id === upsellEntry.productGID) ||
        cfg.otherProducts[0];
      const variant = product?.variants?.[0];
      if (!product || !variant) return null;
      return { entry: upsellEntry, product, variant };
    }

    function renderHub(cfg, state) {
      const u = resolveUpsell(cfg);
      if (!u) return '';
      const { entry, product, variant } = u;
      const hasCompare = variant.compareAtPrice > variant.price;
      return `
        <div class="et-bundle__hub">
          <h4 class="et-bundle__hub-heading">${escapeHtml(t('hub_heading'))}</h4>
          <div class="et-bundle__hub-card ${state.upsellOn ? '' : 'is-off'}" data-upsell-id="${escapeHtml(entry.id)}">
            <div class="et-bundle__hub-thumb" style="background-image:url('${escapeHtml(product.image || variant.image || '')}');"></div>
            <div class="et-bundle__hub-body">
              <h5 class="et-bundle__hub-title">${escapeHtml(product.title)}</h5>
              <div class="et-bundle__hub-prices">
                ${hasCompare ? `<span class="et-bundle__hub-compare">${fmtMoney(variant.compareAtPrice, cfg.moneyFormat)}</span>` : ''}
                <span class="et-bundle__hub-price">${fmtMoney(variant.price, cfg.moneyFormat)}</span>
              </div>
            </div>
            <button type="button" class="et-bundle__hub-toggle" data-action="toggle-upsell" role="switch" aria-checked="${state.upsellOn}">
              <span class="et-bundle__hub-toggle-knob"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M6.49998 12C6.36746 11.9982 6.24039 11.9469 6.14373 11.8562L2.64373 8.35623C2.564 8.25908 2.52325 8.13575 2.52942 8.01023C2.53558 7.8847 2.58822 7.76595 2.67709 7.67709C2.76595 7.58822 2.8847 7.53558 3.01023 7.52942C3.13575 7.52325 3.25908 7.564 3.35623 7.64373L6.49998 10.7937L13.1437 4.14373C13.2409 4.064 13.3642 4.02325 13.4897 4.02942C13.6153 4.03558 13.734 4.08822 13.8229 4.17709C13.9117 4.26595 13.9644 4.3847 13.9705 4.51023C13.9767 4.63575 13.936 4.75908 13.8562 4.85623L6.85623 11.8562C6.75957 11.9469 6.6325 11.9982 6.49998 12Z" fill="white"/>
</svg></span>
            </button>
          </div>
        </div>`;
    }
  
    // ---------- modal render ----------
    function renderModal(block) {
      const inst = instances.get(block);
      if (!inst) return;
      const { cfg, state } = inst;
  
      let portal = inst.portal;
      let overlay = inst.overlay;
      let panel = inst.panel;
      if (!portal) {
        // Mount on documentElement to escape any body-level transforms / filters
        // that can break position:fixed (theme editor preview iframe, animations, etc.)
        portal = document.createElement('div');
        portal.className = 'et-bundle__portal';
        document.documentElement.appendChild(portal);
        inst.portal = portal;
      }
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'et-bundle__panel-overlay';
        overlay.addEventListener('click', () => closeModal(block));
        portal.appendChild(overlay);
        inst.overlay = overlay;
      }
      if (!panel) {
        panel = document.createElement('aside');
        panel.className = 'et-bundle__panel';
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-label', 'Mix & Match');
        portal.appendChild(panel);
        inst.panel = panel;
      }
  
      overlay.classList.toggle('is-open', state.modalOpen);
      panel.classList.toggle('is-open', state.modalOpen);
      document.body.classList.toggle('et-bundle-open', state.modalOpen);
  
      // Bind close-on-click to the existing rebuy backdrop (so its visual
      // dimming doubles as our overlay click-target).
      if (state.modalOpen && !inst.rebuyBgBound) {
        const rebuyBg = document.querySelector('.rebuy-cart__background');
        if (rebuyBg) {
          rebuyBg.addEventListener('click', () => closeModal(block));
          inst.rebuyBgBound = true;
        }
      }
  
      if (!state.modalOpen) return;
  
      const totalPicked = computePickedCount(state);
      const tierBar = pickTier(cfg, totalPicked);
      const minRequired = 2;
  
      const grandTotal = computeGrandTotal(cfg, state, tierBar);

      // Preserve the product grid's scroll position across the full re-render
      // below (replacing innerHTML recreates the scroll container and would
      // otherwise reset it to the top on every add / variant change).
      const prevScrollTop = panel.querySelector('.et-bundle__panel-grid')?.scrollTop || 0;

      panel.innerHTML = `
        <header class="et-bundle__panel-header">
          <div class="et-bundle__panel-top">
            <div class="et-bundle__panel-title-row">
              <h2 class="et-bundle__panel-title">${escapeHtml(t('modal_title'))}</h2>
              <button type="button" class="et-bundle__panel-close" data-action="close-modal" aria-label="Close">
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                </svg>
              </button>
            </div>
            ${renderProgress(cfg, totalPicked)}
          </div>
          <p class="et-bundle__panel-desc">${escapeHtml(t('modal_description'))}</p>
        </header>
        <div class="et-bundle__panel-grid">
          ${cfg.collectionBreaks.map((p) => renderProductCard(p, state, cfg)).join('')}
        </div>
        <footer class="et-bundle__panel-footer ${state.footerOpen ? 'is-open' : ''}">
          <button type="button" class="et-bundle__panel-show" data-action="toggle-combo">
            <svg class="et-bundle__panel-show-chevron" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M4 10l4-4 4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>${escapeHtml(state.footerOpen ? t('combo_hide') : t('combo_show'))} <span class="et-bundle__panel-show-meta">(${totalPicked} ${escapeHtml(pluralProduct(totalPicked))})</span></span>
          </button>
          <div class="et-bundle__panel-combo">
            ${renderComboCards(cfg, state)}
          </div>
          <div class="et-bundle__panel-actions">
            <div class="et-bundle__panel-total">
              <div class="et-bundle__panel-total-row">
                <span class="et-bundle__panel-total-price">${fmtMoney(grandTotal.total, cfg.moneyFormat)}</span>
                ${grandTotal.compareTotal > grandTotal.total ? `<span class="et-bundle__panel-total-compare">${fmtMoney(grandTotal.compareTotal, cfg.moneyFormat)}</span>` : ''}
              </div>
              ${grandTotal.compareTotal > grandTotal.total ? `<span class="et-bundle__panel-savings">${escapeHtml(t('savings_prefix'))} ${fmtMoney(grandTotal.compareTotal - grandTotal.total, cfg.moneyFormat)}</span>` : ''}
            </div>
            <button type="button" class="et-bundle__panel-atc ${totalPicked >= minRequired ? 'is-ready' : ''}" data-action="atc" ${totalPicked >= minRequired ? '' : 'disabled'}>
              ${escapeHtml(t('atc_button'))}
            </button>
          </div>
        </footer>
      `;
  
      // Restore the grid scroll position captured before the re-render.
      const newGrid = panel.querySelector('.et-bundle__panel-grid');
      if (newGrid) newGrid.scrollTop = prevScrollTop;

      panel.querySelector('[data-action="close-modal"]')?.addEventListener('click', () => closeModal(block));
      panel.querySelector('[data-action="toggle-combo"]')?.addEventListener('click', () => {
        state.footerOpen = !state.footerOpen;
        renderModal(block);
      });
      panel.querySelector('[data-action="atc"]')?.addEventListener('click', () => doAtc(block));
  
      // Combo card remove (X) buttons — remove one unit per click
      panel.querySelectorAll('[data-action="combo-remove"]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const pid = parseInt(btn.dataset.productId, 10);
          bumpPick(state, pid, -1);
          renderModal(block);
        });
      });
  
      panel.querySelectorAll('.et-bundle__pcard').forEach((card) => {
        const pid = parseInt(card.dataset.productId, 10);
        card.querySelector('[data-action="pcard-add"]')?.addEventListener('click', () => {
          // Variant resolution: explicit selection > dropdown value > first available variant.
          let vid = state.selectedVariants?.[pid] || card.querySelector('select')?.value;
          if (!vid) {
            const product = cfg.product.id === pid ? cfg.product : cfg.collectionBreaks.find((p) => p.id === pid);
            const firstAvail = product?.variants?.find((v) => v.availableForSale) || product?.variants?.[0];
            vid = firstAvail?.id;
          }
          addPick(state, pid, vid);
          renderModal(block);
        });
        card.querySelector('[data-action="pcard-inc"]')?.addEventListener('click', () => {
          bumpPick(state, pid, +1);
          renderModal(block);
        });
        card.querySelector('[data-action="pcard-dec"]')?.addEventListener('click', () => {
          bumpPick(state, pid, -1);
          renderModal(block);
        });
        // Dropdown variant change
        card.querySelector('[data-action="pcard-variant"]')?.addEventListener('change', (e) => {
          const vid = parseInt(e.target.value, 10);
          state.selectedVariants = state.selectedVariants || {};
          state.selectedVariants[pid] = vid;
          if (state.picks[pid]) state.picks[pid].variantId = vid;
          renderModal(block);
        });
        // Swatch click
        card.querySelectorAll('[data-action="pcard-swatch"]').forEach((swatch) => {
          swatch.addEventListener('click', () => {
            const vid = parseInt(swatch.dataset.variantId, 10);
            state.selectedVariants = state.selectedVariants || {};
            state.selectedVariants[pid] = vid;
            if (state.picks[pid]) state.picks[pid].variantId = vid;
            renderModal(block);
          });
        });
      });
    }
  
    function renderProgress(cfg, count) {
      const bars = cfg.dealBars.filter((b) => b.dealBarType === 'quantity-break');
      const n = bars.length;
      // Even spread: first dot anchored to bar's left edge (left:0),
      // last dot anchored to right edge (right:0), middle dots at proportional %.
      const dotPosPct = (i) => n <= 1 ? 50 : (i / (n - 1)) * 100;
  
      let lastActiveIdx = -1;
      bars.forEach((b, i) => { if (count >= b.quantity) lastActiveIdx = i; });
  
      // Fill connects first dot center (8px from left) to last active dot center.
      let fillStyle = 'width:0;';
      if (lastActiveIdx > 0) {
        if (lastActiveIdx === n - 1) {
          fillStyle = 'left:8px;width:calc(100% - 16px);';
        } else {
          fillStyle = `left:8px;width:calc(${dotPosPct(lastActiveIdx)}% - 8px);`;
        }
      }
  
      const edgeCls = (i) => i === 0 ? '--first' : (i === n - 1 ? '--last' : '--mid');
      const inlineStyle = (i) => (i === 0 || i === n - 1) ? '' : `style="left:${dotPosPct(i)}%;"`;
  
      return `
        <div class="et-bundle__progress">
          <div class="et-bundle__progress-labels">
            ${bars.map((b, i) => `<span class="et-bundle__progress-label et-bundle__progress-label${edgeCls(i)}${count >= b.quantity ? ' is-active' : ''}" ${inlineStyle(i)}>${b.quantity} ${escapeHtml(pluralProduct(b.quantity))}</span>`).join('')}
          </div>
          <div class="et-bundle__progress-bar">
            <div class="et-bundle__progress-fill" style="${fillStyle}"></div>
            ${bars.map((b, i) => {
              const active = count >= b.quantity;
              return `<div class="et-bundle__progress-dot et-bundle__progress-dot${edgeCls(i)}${active ? ' is-active' : ''}" ${inlineStyle(i)}></div>`;
            }).join('')}
          </div>
          <div class="et-bundle__progress-badges">
            ${bars.map((b, i) => {
              const pct = (b.label || '').match(/(\d+)\s*%/)?.[1] || '';
              return `<span class="et-bundle__progress-badge et-bundle__progress-badge${edgeCls(i)}${count >= b.quantity ? ' is-active' : ''}" ${inlineStyle(i)}>-${pct}%</span>`;
            }).join('')}
          </div>
        </div>
      `;
    }
  
    function getDisplayVariantId(p, state) {
      if (state.selectedVariants?.[p.id]) return state.selectedVariants[p.id];
      if (state.picks[p.id]?.variantId) return state.picks[p.id].variantId;
      const firstAvail = p.variants?.find((v) => v.availableForSale) || p.variants?.[0];
      return firstAvail?.id;
    }
  
    function renderProductCard(p, state, cfg) {
      const pick = state.picks[p.id];
      const displayVariantId = getDisplayVariantId(p, state);
      const variantToShow = findVariant(p, displayVariantId) || p.variants?.[0];
      if (!variantToShow) return '';
  
      const option = p.options?.[0];
      const availableVariants = (p.variants || []).filter((v) => v.availableForSale);
      const hasMultipleVariants = availableVariants.length > 1;
      const colorMode = hasMultipleVariants && isColorOption(option);
      const dropdownMode = hasMultipleVariants && !colorMode;
  
      const qty = pick ? pick.quantity : 0;
      const img = p.image || variantToShow.image || '';
  
      return `
        <div class="et-bundle__pcard" data-product-id="${p.id}">
          <div class="et-bundle__pcard-image-wrap">
            ${img ? `<img class="et-bundle__pcard-image" src="${escapeHtml(img)}" alt="${escapeHtml(p.title)}" loading="lazy">` : ''}
          </div>
          <div class="et-bundle__pcard-body">
            <h4 class="et-bundle__pcard-title">${escapeHtml(p.title)}</h4>
            <div class="et-bundle__pcard-prices">
              <span class="et-bundle__pcard-price">${fmtMoney(variantToShow.price, cfg.moneyFormat)}</span>
              ${variantToShow.compareAtPrice > variantToShow.price ? `<span class="et-bundle__pcard-compare">${fmtMoney(variantToShow.compareAtPrice, cfg.moneyFormat)}</span>` : ''}
            </div>
          </div>
          ${colorMode ? renderSwatches(variantToShow, option, availableVariants) : ''}
          ${dropdownMode ? renderVariantPill(variantToShow, option, availableVariants) : ''}
          <div class="et-bundle__pcard-action">
            ${qty > 0 ? `
              <div class="et-bundle__pcard-stepper">
                <button type="button" data-action="pcard-dec" aria-label="Decrease">
                  <svg viewBox="0 0 16 16" width="16" height="16" fill="none" aria-hidden="true">
                    <rect x="3" y="7.25" width="10" height="1.5" rx="0.75" fill="currentColor"/>
                  </svg>
                </button>
                <span class="et-bundle__pcard-stepper-value">${qty}</span>
                <button type="button" data-action="pcard-inc" aria-label="Increase">
                  <svg viewBox="0 0 16 16" width="16" height="16" fill="none" aria-hidden="true">
                    <rect x="3" y="7.25" width="10" height="1.5" rx="0.75" fill="currentColor"/>
                    <rect x="7.25" y="3" width="1.5" height="10" rx="0.75" fill="currentColor"/>
                  </svg>
                </button>
              </div>
            ` : `
              <button type="button" class="et-bundle__pcard-add" data-action="pcard-add">${escapeHtml(t('card_add_button'))}</button>
            `}
          </div>
        </div>
      `;
    }
  
    function renderSwatches(currentVariant, option, availableVariants) {
      const currentLabel = currentVariant.options?.[0] || '';
      return `
        <div class="et-bundle__pcard-swatches">
          <div class="et-bundle__pcard-swatch-label">
            <span class="et-bundle__pcard-swatch-label-key">${escapeHtml(option.name)}:</span>
            <span class="et-bundle__pcard-swatch-label-value">${escapeHtml(currentLabel)}</span>
          </div>
          <div class="et-bundle__pcard-swatch-row">
            ${availableVariants.map((v) => {
              const optVal = v.options?.[0] || '';
              const color = getOptionColor(optVal) || '#ccc';
              const isSelected = v.id === currentVariant.id;
              return `<button type="button" class="et-bundle__pcard-swatch ${isSelected ? 'is-selected' : ''}" data-variant-id="${v.id}" data-action="pcard-swatch" title="${escapeHtml(optVal)}" aria-label="${escapeHtml(optVal)}"><span class="et-bundle__pcard-swatch-color" style="background:${color};"></span></button>`;
            }).join('')}
          </div>
        </div>
      `;
    }
  
    function renderVariantPill(currentVariant, option, availableVariants) {
      const currentLabel = currentVariant.options?.[0] || '';
      return `
        <div class="et-bundle__pcard-variant">
          <span class="et-bundle__pcard-variant-key">${escapeHtml(option.name)}:</span>
          <span class="et-bundle__pcard-variant-value">${escapeHtml(currentLabel)}</span>
          <svg class="et-bundle__pcard-variant-chevron" viewBox="0 0 16 16" width="16" height="16" fill="none" aria-hidden="true">
            <path d="M6 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <select class="et-bundle__pcard-variant-select" data-action="pcard-variant">
            ${availableVariants.map((v) => `<option value="${v.id}" ${v.id === currentVariant.id ? 'selected' : ''}>${escapeHtml(v.options?.[0] || '')}${v.options?.[1] ? ` (${escapeHtml(v.options[1])})` : ''}</option>`).join('')}
          </select>
        </div>
      `;
    }
  
    function renderComboCards(cfg, state) {
      // Flatten picks: each unit = one slot in the slider.
      const productMap = {};
      for (const p of [cfg.product, ...cfg.collectionBreaks]) productMap[p.id] = p;
  
      const slots = [];
      for (const [pid, pick] of Object.entries(state.picks)) {
        const p = productMap[pid];
        if (!p) continue;
        // Fallback to first available variant if pick.variantId is missing.
        const v = findVariant(p, pick.variantId)
          || p.variants?.find((x) => x.availableForSale)
          || p.variants?.[0];
        if (!v) continue;
        for (let i = 0; i < pick.quantity; i++) {
          slots.push({ product: p, variant: v, pid: parseInt(pid, 10) });
        }
      }
  
      if (!slots.length) {
        return `<div class="et-bundle__combo-empty">${escapeHtml(t('combo_empty'))}</div>`;
      }
  
      return slots.map((slot) => {
        const { product, variant, pid } = slot;
        const optName = product.options?.[0]?.name || '';
        const optVal = variant.options?.[0] || '';
        const showLabel = optName && optVal && optVal.toLowerCase() !== 'default title';
        const img = product.image || variant.image || '';
        return `
          <div class="et-bundle__combo-slot" style="background-image:url('${escapeHtml(img)}');">
            <button type="button" class="et-bundle__combo-slot-remove" data-action="combo-remove" data-product-id="${pid}" aria-label="Remove">
              <svg viewBox="0 0 16 16" width="14" height="14" fill="none" aria-hidden="true">
                <path d="M5 5l6 6M11 5l-6 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
              </svg>
            </button>
            ${showLabel ? `<span class="et-bundle__combo-slot-label">${escapeHtml(optName)}: ${escapeHtml(optVal)}</span>` : ''}
          </div>
        `;
      }).join('');
    }
  
    // ---------- state ops ----------
    function computePickedCount(state) {
      let n = 0;
      for (const pick of Object.values(state.picks)) n += pick.quantity;
      return n;
    }
    function pickTier(cfg, count) {
      let active = null;
      for (const b of cfg.dealBars) {
        if (b.dealBarType !== 'quantity-break') continue;
        if (count >= b.quantity) active = b;
      }
      return active;
    }
    function computeGrandTotal(cfg, state, tierBar) {
      let sumPrice = 0, sumCompare = 0;
      const productMap = {};
      for (const p of [cfg.product, ...cfg.collectionBreaks]) productMap[p.id] = p;
      for (const [pid, pick] of Object.entries(state.picks)) {
        const p = productMap[pid];
        if (!p) continue;
        const v = findVariant(p, pick.variantId);
        if (!v) continue;
        sumPrice += v.price * pick.quantity;
        sumCompare += (v.compareAtPrice || v.price) * pick.quantity;
      }
      // Tier discount applies to picks (bundle items) only.
      let total = applyTierDiscount(sumPrice, tierBar, cfg);
  
      // Upsell (Video Training Guide etc.) is a separate line item — its own
      // discount lives in compareAtPrice, NOT subject to tier multiplier.
      if (state.upsellOn && cfg.checkboxUpsells?.[0]) {
        const ups = cfg.checkboxUpsells[0];
        const upProduct = cfg.otherProducts.find((p) => 'gid://shopify/Product/' + p.id === ups.productGID) || cfg.otherProducts[0];
        const upVariant = upProduct?.variants?.[0];
        if (upVariant) {
          total += upVariant.price;
          sumCompare += upVariant.compareAtPrice || upVariant.price;
        }
      }
  
      return { total, compareTotal: sumCompare };
    }
    function addPick(state, productId, variantIdStr) {
      const variantId = variantIdStr ? parseInt(variantIdStr, 10) : null;
      if (state.picks[productId]) {
        state.picks[productId].quantity += 1;
        if (variantId) state.picks[productId].variantId = variantId;
      } else {
        state.picks[productId] = { variantId, quantity: 1 };
      }
    }
    function bumpPick(state, productId, delta) {
      const pick = state.picks[productId];
      if (!pick) return;
      pick.quantity += delta;
      if (pick.quantity <= 0) delete state.picks[productId];
    }
    function closeModal(block) {
      const inst = instances.get(block);
      if (!inst) return;
      inst.state.modalOpen = false;
      document.body.classList.remove('et-bundle-open');
      renderModal(block);
    }
  
    // ---------- ATC ----------
    // Build the picks map for a preset quantity tier (one unit per slot).
    function presetPicks(cfg, tier, state) {
      const picks = {};
      for (const p of presetSlots(cfg, tier.quantity)) {
        const v = slotVariant(p, state);
        if (picks[p.id]) picks[p.id].quantity += 1;
        else picks[p.id] = { variantId: v?.id, quantity: 1, source: p.id === cfg.product.id };
      }
      return picks;
    }

    // Toggle a button's loading state. Native theme buttons use the `.loading`
    // class (their own spinner); our modal button also swaps its text label.
    function setBtnLoading(btn, on, useText) {
      if (!btn) return;
      if (on) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
        if (useText) {
          if (btn.dataset.prevLabel == null) btn.dataset.prevLabel = btn.textContent;
          btn.disabled = true;
          btn.textContent = t('atc_adding');
        }
      } else {
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('loading');
        if (useText) {
          btn.disabled = false;
          if (btn.dataset.prevLabel != null) { btn.textContent = btn.dataset.prevLabel; delete btn.dataset.prevLabel; }
        }
      }
    }

    const cartHeaders = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

    // After an add, force the checkbox-upsell line to match the toggle:
    // quantity 1 when on, removed when off. Kaching auto-injects its preselected
    // upsell on any bundle add, so we normalise it here regardless of who added it.
    async function reconcileUpsell(inst, bundleId, deal) {
      const u = resolveUpsell(inst.cfg);
      if (!u) return;
      const want = inst.state.upsellOn ? 1 : 0;
      let cart;
      try { cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then((r) => r.json()); }
      catch (e) { return; }
      const lines = (cart.items || []).filter((it) => it.variant_id === u.variant.id);
      const have = lines.reduce((n, l) => n + l.quantity, 0);
      if (have === want) return;

      if (have > want) {
        for (const l of lines) {
          await fetch('/cart/change.js', { method: 'POST', headers: cartHeaders, body: JSON.stringify({ id: l.key, quantity: 0 }) });
        }
        if (want > 0) await addUpsellLine(u, want, bundleId, deal);
      } else {
        await addUpsellLine(u, want - have, bundleId, deal);
      }
    }
    function addUpsellLine(u, qty, bundleId, deal) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: cartHeaders,
        body: JSON.stringify({ items: [{
          id: u.variant.id,
          quantity: qty,
          properties: { __kaching_bundles: JSON.stringify({ id: bundleId, deal, checkboxUpsell: u.entry.id }) },
        }] }),
      });
    }

    // Core add-to-cart. Adds source + slot extras ourselves in one POST, then
    // reconciles the checkbox upsell to the toggle. Kaching's discount applies via
    // the `__kaching_bundles` line-item properties. Then we refresh + open the drawer.
    async function submitBundle(block, picks, chosenBar, statusBtn, useText) {
      const inst = instances.get(block);
      if (!inst) return;
      const { cfg, state } = inst;

      const bundleId = nonce();
      const deal = cfg.dealNanoId;

      const productMap = {};
      for (const p of [cfg.product, ...cfg.collectionBreaks, ...(cfg.bundleProducts || [])]) productMap[p.id] = p;

      const items = [];
      for (const [pid, pick] of Object.entries(picks)) {
        const p = productMap[pid];
        if (!p || pick.quantity <= 0) continue;
        const v = findVariant(p, pick.variantId) || p.variants?.find((x) => x.availableForSale) || p.variants?.[0];
        if (!v || !v.availableForSale) continue;
        const isSource = parseInt(pid, 10) === cfg.product.id;
        const props = isSource
          ? { id: bundleId, deal, main: true }
          : { id: bundleId, deal, collectionBreaksProduct: true };
        if (isSource && chosenBar) props.bid = chosenBar.id;
        const item = { id: v.id, quantity: pick.quantity, properties: { __kaching_bundles: JSON.stringify(props) } };
        if (isSource) items.unshift(item); else items.push(item); // main first
      }
      if (!items.length) return;

      // Add the checkbox upsell ONLY when the toggle is active (by its variant id).
      if (state.upsellOn) {
        const u = resolveUpsell(cfg);
        if (u) {
          items.push({
            id: u.variant.id,
            quantity: 1,
            properties: { __kaching_bundles: JSON.stringify({ id: bundleId, deal, checkboxUpsell: u.entry.id }) },
          });
        }
      }

      setBtnLoading(statusBtn, true, useText);
      try {
        // Plain add (no `kaching_bundles=true`): we build the full cart ourselves,
        // so Kaching must NOT re-process the add and inject its preselected checkbox
        // upsell. The bundle discount still applies from the `__kaching_bundles`
        // line-item properties, which Kaching's discount function reads server-side.
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) throw new Error('cart add failed: ' + res.status);

        // Force the upsell line to match the toggle (Kaching may have injected it).
        await reconcileUpsell(inst, bundleId, deal);

        closeModal(block);
        // Refresh + open the theme cart drawer using its own hooks.
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.getElementById('cart-drawer-toggle')?.click();
      } catch (e) {
        console.error('[et-bundle] ATC failed', e);
      } finally {
        setBtnLoading(statusBtn, false, useText);
      }
    }

    // Modal (Build Your Bundle) ATC — uses the user-assembled picks.
    async function doAtc(block) {
      const inst = instances.get(block);
      if (!inst) return;
      const { cfg, state } = inst;
      const totalPicked = computePickedCount(state);
      if (totalPicked < 1) return;
      const btn = inst.panel?.querySelector('[data-action="atc"]');
      await submitBundle(block, state.picks, pickTier(cfg, totalPicked), btn, true);
    }

    // Kaching keeps its own (hidden) checkbox-upsell selected by default, so its
    // add flow auto-injects the upsell. Deselect it so Kaching never adds the
    // upsell — we own it entirely (added only when our toggle is on).
    function deselectKachingUpsell() {
      const inputs = document.querySelectorAll(
        '.kaching-bundles__checkbox-upsell input[type="checkbox"],' +
        '.kaching-bundles__checkbox-upsells input[type="checkbox"],' +
        '[class*="checkbox-upsell"] input[type="checkbox"]'
      );
      inputs.forEach((cb) => {
        if (cb.checked) cb.click(); // toggle off via Kaching's own handler
      });
    }

    // Run our ATC for the selected tier. Returns true if handled.
    function handleTierAtc(block, statusBtn) {
      const inst = instances.get(block);
      if (!inst) return false;
      deselectKachingUpsell();
      const tiers = inst.tiers || buildTiers(inst.cfg);
      const tier = tiers[inst.state.selectedTierIndex];
      if (!tier) return false;
      if (tier.type === 'build') {
        inst.state.modalOpen = true;
        renderModal(block);
        return true;
      }
      submitBundle(block, presetPicks(inst.cfg, tier, inst.state), tier.bar, statusBtn, false);
      return true;
    }

    // Fully replace the theme/Kaching Add-to-Cart. We hook both the product FORM's
    // submit (what the main button, the sticky button via `form=`, and Enter all
    // trigger — and where Kaching attaches its own bundle-expansion handler) AND the
    // buttons directly. `stopImmediatePropagation` prevents Kaching from running and
    // injecting its preselected upsell.
    function bindNativeAtc(block) {
      const inst = instances.get(block);
      if (!inst) return;

      document.querySelectorAll('form[action*="/cart/add"], form.kaching-bundles-form, form.product-form, product-form form').forEach((form) => {
        if (form.dataset.etAtcBound || !form.querySelector('[name="add"]')) return;
        form.dataset.etAtcBound = '1';
        form.addEventListener('submit', (ev) => {
          ev.preventDefault();
          ev.stopImmediatePropagation();
          handleTierAtc(block, form.querySelector('[name="add"]'));
        }, true);
      });

      document.querySelectorAll('.single-add-to-cart-button, button[name="add"], [name="add"][type="submit"]').forEach((btn) => {
        if (btn.dataset.etAtcBound) return;
        btn.dataset.etAtcBound = '1';
        btn.addEventListener('click', (ev) => {
          ev.preventDefault();
          ev.stopImmediatePropagation();
          handleTierAtc(block, btn);
        }, true);
      });
    }
  })();